import React from 'react';
import { BaseWizardProps } from '../wizard/wizard-step-base';
import {
  GoAButton,
  GoAButtonGroup,
  GoACallout,
  GoASpacer,
} from '@abgov/react-components';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../state/store';
import { useNavigate } from 'react-router-dom';
import { logout } from '../../state/slices/authSlice';

export interface ReviewCompleteProps extends BaseWizardProps {}

const useAppDispatch = () => useDispatch<AppDispatch>();
const useAppSelector: <TSelected>(
  selector: (state: RootState) => TSelected,
) => TSelected = useSelector;

export const ReviewCompleteComponent = ({
  navigationConfiguration,
}: ReviewCompleteProps) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const stateCollision = useAppSelector((state: RootState) => state.collision);
  const stateAuth = useAppSelector((state: RootState) => state.auth);
  const stateConfiguration = useAppSelector(
    (state: RootState) => state.configuration,
  );

  return (
    <div>
      <h2>You have completed your collision report</h2>
      <GoASpacer vSpacing={'xl'} />
      <GoACallout type="success">
        <div>
          A confirmation email will be sent to your email address at:{' '}
          {stateCollision.collision.reporterEmail}
        </div>
        <div>Confirmation number: {stateCollision.collision?.id ?? ''}</div>
      </GoACallout>
      <h3>What happens next?</h3>
      <GoASpacer vSpacing={'l'} />
      <div>
        Your submitted report will be forwarded to law enforcement for review.
        Once approved, your damage sticker will be available for download, and
        the report status will update on the Report My Collision dashboard. You
        will be notified by email about any updates to your report.
        <GoASpacer vSpacing={'l'} />
        You can now close this window or check your dashboard at any time to
        view your report status.
      </div>
      <GoASpacer vSpacing={'l'} />
      <h3>If you have questions about your submitted report</h3>
      <GoASpacer vSpacing={'l'} />
      <div>Contact the Ministry of Transportation and Economic Corridors</div>
      <GoASpacer vSpacing={'l'} />
      <div>
        Email:{' '}
        <a href="mailto:tec.collisionsupport@gov.ab.ca">
          tec.collisionsupport@gov.ab.ca
        </a>
      </div>
      <div>
        Toll free: 310-0000 (in Alberta), phone: 587-985-3560 available Monday
        to Friday between 8:15 am to 4:30 pm (closed statutory holidays)
      </div>
      <GoASpacer vSpacing={'xl'} />
      <GoAButtonGroup alignment="start">
        <GoAButton
          onClick={() => {
            navigate('/dashboard');
          }}
        >
          Back to dashboard
        </GoAButton>
        <GoAButton
          onClick={() => {
            localStorage.clear();
            sessionStorage.clear();
            dispatch(logout());
          }}
          type="tertiary"
        >
          Sign out
        </GoAButton>
      </GoAButtonGroup>
    </div>
  );
};

export default ReviewCompleteComponent;
